import React from 'react';
import SubscriptionList from './Component/Subscription/SubscriptionList';
import { useTranslation } from "react-i18next";
import AppTabs from 'components/CustomTabs/AppTabs';
import SubscriptionListHistories from './Component/Subscription/SubscriptionListHistories';

const SubscriptionManagement = () => {
    const { t } = useTranslation();

    const tabs = [
        {
            tabLabel: t('label.list_subscribed'),
            tabContent: <SubscriptionListHistories />
        },
        {
            tabLabel: t('label.new_subscription_plan'),
            tabContent: <SubscriptionList/>
        }
    ]
    return (
        <AppTabs
            swipeable={false}
            tabs={tabs}
    />
    )
}

export default SubscriptionManagement;
